/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from "react";
import "./Welcome.css";
import WebChatLogo from "../../assets/web-chat-logo.png";
import { TopBar } from "../../components/topBar/TopBar";
import { ChatOptions } from "../../components/welcome/mobile/chatOptions/ChatOptions";
import { Strings } from "../../utils/strings";
import { useNavigate } from "react-router-dom";
import { useWebChat } from "../../context/webChatContext";
import LoadingIndicator from "../../components/loadingIndicator/LoadingIndicator";

type props = {};

export const Welcome: React.FC<props> = () => {
  const navigate = useNavigate();
  const { handleCreateChannel } = useWebChat();
  const [loading, setLoading] = useState(false);

  return (
    <div className="welcome-container">
      <TopBar />
      <img src={WebChatLogo} alt="" className="welcome-logo" />
      <span className="welcome-title">{Strings.WELCOME}</span>
      <span className="welcome-desc">{Strings.WELCOME_DESC}</span>
      <ChatOptions
        onPress={async (chat) => {
          setLoading(true);
          const channel = await handleCreateChannel();
          const message = await channel?.sendMessage({
            text: chat.label,
          });
          setLoading(false);
          navigate("/chat");
        }}
      />
      {loading && <LoadingIndicator loading />}
    </div>
  );
};
